export const localStorageHelper = {
  setAItokenLeft: (tokenCount) => {
    try {
      return window.localStorage.setItem(
        "AITokenLeft",
        JSON.stringify(tokenCount)
      );
    } catch (e) {
      console.error("Error setting AITokenLeft to local storage:", e);
      return null;
    }
  },

  getAItokenLeft: () => {
    try {
      return JSON.parse(window.localStorage.getItem("AITokenLeft"));
    } catch (e) {
      console.error("Error retrieving AITokenLeft from local storage:", e);
      return 0;
    }
  },
};

export const setDoNotShowDeletePopupAgainValue = (booleanValue = true) => {
  try {
    return window.localStorage.setItem(
      "DoNotShowDeletePopupAgainValue",
      JSON.stringify(booleanValue)
    );
  } catch (e) {
    console.error("Error setting doNotShowThisPopup to local storage:", e);
    return null;
  }
};

export const getDoNotShowDeletePopupAgainValue = () => {
  try {
    const value = window.localStorage.getItem("DoNotShowDeletePopupAgainValue");

    // If key doesn't exist or its value is null/undefined, return true as the default
    if (value === null || value === undefined) {
      return false;
    }

    return JSON.parse(value);
  } catch (e) {
    console.error(
      "Error retrieving showDeleteEmailsPopup from local storage:",
      e
    );
    return true; // Default to true in case of an error
  }
};
